import script from "./PostContributionSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./PostContributionSupport.vue?vue&type=script&setup=true&lang=js"

import "./PostContributionSupport.vue?vue&type=style&index=0&id=3c54f169&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c54f169"]])

export default __exports__